import { render, staticRenderFns } from "./BatchTransfer.vue?vue&type=template&id=3cbdbcf2&scoped=true"
import script from "./BatchTransfer.vue?vue&type=script&lang=js"
export * from "./BatchTransfer.vue?vue&type=script&lang=js"
import style0 from "./BatchTransfer.vue?vue&type=style&index=0&id=3cbdbcf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbdbcf2",
  null
  
)

export default component.exports